import { Button, CircularProgress } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'formik-mui';
import React from 'react';

type VerifyCodeProps = {
  disabled: boolean;
  resendCode: () => void;
};

const VerifyCodeForm: React.FC<VerifyCodeProps> = ({
  disabled,
  resendCode,
}) => {
  return (
    <>
      <Field
        component={TextField}
        required
        fullWidth
        margin="normal"
        label="Verification Code"
        id="code"
        name="code"
        disabled={disabled}
      />
      <Button
        type="button"
        variant="contained"
        color="secondary"
        fullWidth
        sx={{ mt: 2 }}
        disabled={disabled}
        onClick={resendCode}
      >
        {disabled ? <CircularProgress size={24} /> : 'Send another code'}
      </Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        disabled={disabled}
      >
        {disabled ? <CircularProgress size={24} /> : 'Submit'}
      </Button>
    </>
  );
};

export default VerifyCodeForm;
